/**
 * SplitScreenBrandPanel
 *
 * Reusable branded left column for the dual-column screens built on
 * SplitScreenLayout (public share password gate / error states, app bootstrap
 * failure). Renders the brand logo, a heading, a description and a footer note
 * with the shared staggered fade-in, mirroring the onboarding / invitation left
 * panels. Copy is supplied by the caller via props.
 *
 * @module components/common/SplitScreenBrandPanel
 */
import { type ReactNode, memo } from 'react';

import { BrandLogo } from '@/components/common/BrandLogo';
import splitStyles from '@/components/layout/SplitScreenLayout/SplitScreenLayout.module.css';

import styles from './SplitScreenBrandPanel.module.css';

interface SplitScreenBrandPanelProps {
  heading: string;
  description: string;
  footer: string;
}

export const SplitScreenBrandPanel = memo(function SplitScreenBrandPanel({
  heading,
  description,
  footer,
}: SplitScreenBrandPanelProps): ReactNode {
  return (
    <>
      <div className={`${splitStyles.fadeElement} ${splitStyles.fadeDelay0}`}>
        <BrandLogo linkToHome />
      </div>

      <div className={styles.leftCenterBlock}>
        <h1
          className={`${styles.leftHeading} ${splitStyles.fadeElement} ${splitStyles.fadeDelay1}`}
        >
          {heading}
        </h1>
        <p
          className={`${styles.leftDescription} ${splitStyles.fadeElement} ${splitStyles.fadeDelay2}`}
        >
          {description}
        </p>
      </div>

      <p
        className={`${styles.leftFooter} ${splitStyles.fadeElement} ${splitStyles.fadeDelay3}`}
      >
        {footer}
      </p>
    </>
  );
});
